import { Box, Skeleton, Typography, alpha, useTheme } from "@mui/material";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const COLORS = {
  "Sem vínculo": "#b45309",
  Parcial: "#1d6fb8",
  Finalizado: "#2e7d52",
};

const ChartShell = ({ title, subtitle, children, isDark }) => (
  <Box
    sx={{
      border: "1px solid var(--ctrl-border)",
      borderRadius: "14px",
      bgcolor: "var(--ctrl-surface)",
      p: 2.25,
      minHeight: 320,
      display: "flex",
      flexDirection: "column",
      boxShadow: isDark
        ? "0 8px 24px rgba(0,0,0,0.22)"
        : "0 8px 22px rgba(27,58,75,0.06)",
    }}
  >
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: 15,
        color: "var(--ctrl-text)",
        mb: 0.5,
      }}
    >
      {title}
    </Typography>
    <Typography
      sx={{
        fontSize: 12.5,
        color: "var(--ctrl-text-muted)",
        mb: 2,
      }}
    >
      {subtitle}
    </Typography>
    <Box sx={{ flex: 1, minHeight: 240 }}>{children}</Box>
  </Box>
);

const VinculoStatusChart = ({ vinculoPc, loading }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const muted = isDark ? "#94a3b8" : "#64748b";
  const tooltipBg = isDark ? "#1e293b" : "#ffffff";
  const tooltipBorder = isDark ? "#334155" : "#e2e8f0";

  const periodo = vinculoPc?.periodo || {};
  const series = [
    {
      name: "Sem vínculo",
      value: Number(periodo.sem_vinculo) || 0,
    },
    {
      name: "Parcial",
      value: Number(periodo.parcial) || 0,
    },
    {
      name: "Finalizado",
      value: Number(periodo.finalizado) || 0,
    },
  ];

  const hasData = series.some((item) => item.value > 0);

  if (loading) {
    return (
      <ChartShell
        title="Vínculo PC × NF"
        subtitle="Estado dos pedidos do período"
        isDark={isDark}
      >
        <Skeleton
          variant="rounded"
          height="100%"
          sx={{ bgcolor: alpha("#E8A317", 0.1), minHeight: 220 }}
        />
      </ChartShell>
    );
  }

  return (
    <ChartShell
      title="Vínculo PC × NF"
      subtitle="Estado dos pedidos do período"
      isDark={isDark}
    >
      {!hasData ? (
        <Box
          sx={{
            height: "100%",
            minHeight: 220,
            display: "grid",
            placeItems: "center",
            color: "var(--ctrl-text-muted)",
            fontSize: 13,
          }}
        >
          Sem dados para exibir
        </Box>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={series}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="46%"
              innerRadius={58}
              outerRadius={88}
              paddingAngle={2}
              stroke="none"
            >
              {series.map((entry) => (
                <Cell key={entry.name} fill={COLORS[entry.name]} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value) => [value, "Pedidos"]}
              contentStyle={{
                background: tooltipBg,
                border: `1px solid ${tooltipBorder}`,
                borderRadius: 10,
                color: isDark ? "#f1f5f9" : "#0f172a",
                fontSize: 12,
              }}
            />
            <Legend
              verticalAlign="bottom"
              height={36}
              formatter={(value) => (
                <span style={{ color: muted, fontSize: 12 }}>{value}</span>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </ChartShell>
  );
};

export default VinculoStatusChart;
